<template>
	<div class="contacts_right my_info">
		<div class="profile">
			<span class="user_photo AVATAR mb_20"></span>
			<p class="mb_20">아이디</p>
		</div>
		<p class="title">JPYS {{ $t('rtr_pay-contact.account') }}</p>
		<input
			type="text"
			class="w100 readonly"
			value="1234-56789-101231"
			readonly
		/>
		<p class="title">{{ $t('rtr_pay-contact.name') }}</p>
		<input type="text" class="readonly" readonly />
		<p class="title">{{ $t('rtr_pay-contact.location') }}</p>
		<input type="text" class="readonly" readonly />
		<p class="title">{{ $t('rtr_pay-contact.memo') }}</p>
		<textarea class="memo readonly" readonly></textarea>
		<div class="d_flex justify_between">
			<p class="title">
				{{ $t('rtr_pay-contact.status') }}
				<span class="pt_10"
					>{{ $t('rtr_pay-contact.text1') }}<br />
					{{ $t('rtr_pay-contact.text2') }}</span
				>
			</p>
			<div class="switch-toggle">
				<label>
					<input type="checkbox" checked />
					<span></span>
				</label>
			</div>
		</div>

		<div class="button_position">
			<button>{{ $t('button.edit1') }}</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ContactsMyInfo',
};
</script>

<style scoped></style>
